import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c7r7p3a7zr: FaireBrandEntity = {
  token: "b_c7r7p3a7zr",
  type: "brand",
  name: "Balsam Paper Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/ffe5c09f8c6c51a34bfa1a22c3f4c33c888c189c20914ca15aeb1ce7d5c6774f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b46e3ab512f3d52b22dab4c5dd3459a44293e537d34e81e0f3895da1ac99a9c4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ffe5c09f8c6c51a34bfa1a22c3f4c33c888c189c20914ca15aeb1ce7d5c6774f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b46e3ab512f3d52b22dab4c5dd3459a44293e537d34e81e0f3895da1ac99a9c4.jpeg",
  location: "Newmarket, ON, CAN",
  minimumOrderDollars: 45,
  rating: 5,
  reviewCount: 8,
  isInsider: false,
  description:
    "Welcome to Balsam Paper Co.\n\nWe are a Canadian stationery company specializing in simple and thoughtfully designed cards.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:23.003Z",
    importedBy: "entity-db-cli",
  },
};
